import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';
import { MarketBasketOption } from '../types/market-share';

const getMarketShareBaskets = (): Promise<MarketBasketOption[]> => {
  return artiaProtectedApi.get('market-share/market-baskets');
};

export const makeMarketShareBasketsQueryKey = () => ['market-share', 'baskets'];

export const useMarketShareBaskets = () => {
  return useQuery({
    queryKey: makeMarketShareBasketsQueryKey(),
    queryFn: getMarketShareBaskets,
  });
};

export const useMarketShareBasketsSuspense = () => {
  const { data, error, isFetching, dataUpdatedAt } = useSuspenseQuery({
    queryKey: makeMarketShareBasketsQueryKey(),
    queryFn: getMarketShareBaskets,
  });

  if (error && !isFetching) throw error;

  return { data, dataUpdatedAt, isFetching };
};
